<template>
   <v-app>
      <home-app-bar :badge="badge" :clients="clients" />
      <home-view />
      <home-footer />
   </v-app>
</template>

<script>
// eslint-disable-next-line
import { jsonify } from '@/utils/nirtara'
export default {
   name: 'HomeLayout',

   components: {
      HomeAppBar: () => import('@/layouts/home/AppBar'),
      HomeView: () => import('@/layouts/home/View'),
      HomeFooter: () => import('@/layouts/home/Footer'),
   },

   data: () => ({
      badge: { persons: '', locations: '', subjects: '', activities: '', options: '' },
      clients: 0,
   }),
   
   created () {
      this.$waitDomain(zone => {
         // console.log(`created ( src\\layouts\\home\\Index.vue, zone = ${zone || this.$store.state.zone} )`)
         this.$socket.on(`server/${zone}/Message`, (data) => {
            if (data.Server) {
               if (data.welcome) {
                  this.$store.commit('x-forwarded-for', data.Server[0].ipV4)
                  console.log(data.welcome)
               } else if (data.clients) {
                  this.clients = +data.clients
               } else {
                  // do-nothing
               }
            } else if (data.Badge) {
               Object.keys(this.badge).map(key => {
                  if (!data[key]) return
                  if (this.$route.path === `/${key}`) return
                  if (this.$route.path === '/settings' && 'options' === key) return
                  this.badge[key] = (this.badge[key] || 0) + parseInt(data[key])
               })
            } else console.log(`created ( src\\layouts\\home\\Index.vue )`, jsonify(data))
         })
         this.$socket.on(`server/*/Command`, (data) => {
            // console.log(`created ( src\\layouts\\home\\Index.vue )`, jsonify(data))
            const management = data.Command.find(j => j.Management)
            if (management) {
               const managements = this.$store.getters.managements
               const idx = managements.findIndex(j => j.zone === management.zone)
               idx >= 0 && managements.splice(idx, 1)
               data.action !== 'Delete' && managements.push({ name: management.name, zone: management.zone })
               this.$store.commit('managements', managements)
            }
         })
      })
   },
   destroyed () {
      // this.$socket.off(`server/${this.$store.state.zone}/Message`)
   },
}
</script>